/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#hasMemberRelation
 */
export const hasMemberRelation = 'http://www.w3.org/ns/ldp#hasMemberRelation';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#isMemberOfRelation
 */
export const isMemberOfRelation = 'http://www.w3.org/ns/ldp#isMemberOfRelation';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#membershipResource
 */
export const membershipResource = 'http://www.w3.org/ns/ldp#membershipResource';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#insertedContentRelation
 */
export const insertedContentRelation = 'http://www.w3.org/ns/ldp#insertedContentRelation';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#member
 */
export const member = 'http://www.w3.org/ns/ldp#member';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#contains
 */
export const contains = 'http://www.w3.org/ns/ldp#contains';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#constrainedBy
 */
export const constrainedBy = 'http://www.w3.org/ns/ldp#constrainedBy';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#pageSortCriteria
 */
export const pageSortCriteria = 'http://www.w3.org/ns/ldp#pageSortCriteria';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#pageSortPredicate
 */
export const pageSortPredicate = 'http://www.w3.org/ns/ldp#pageSortPredicate';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#pageSortOrder
 */
export const pageSortOrder = 'http://www.w3.org/ns/ldp#pageSortOrder';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#pageSortCollation
 */
export const pageSortCollation = 'http://www.w3.org/ns/ldp#pageSortCollation';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#pageSequence
 */
export const pageSequence = 'http://www.w3.org/ns/ldp#pageSequence';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#inbox
 */
export const inbox = 'http://www.w3.org/ns/ldp#inbox';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#Resource
 */
export const Resource = 'http://www.w3.org/ns/ldp#Resource';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#RDFSource
 */
export const RDFSource = 'http://www.w3.org/ns/ldp#RDFSource';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#NonRDFSource
 */
export const NonRDFSource = 'http://www.w3.org/ns/ldp#NonRDFSource';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#Container
 */
export const Container = 'http://www.w3.org/ns/ldp#Container';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#BasicContainer
 */
export const BasicContainer = 'http://www.w3.org/ns/ldp#BasicContainer';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#DirectContainer
 */
export const DirectContainer = 'http://www.w3.org/ns/ldp#DirectContainer';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#IndirectContainer
 */
export const IndirectContainer = 'http://www.w3.org/ns/ldp#IndirectContainer';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#Page
 */
export const Page = 'http://www.w3.org/ns/ldp#Page';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#PageSortCriterion
 */
export const PageSortCriterion = 'http://www.w3.org/ns/ldp#PageSortCriterion';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#MemberSubject
 */
export const MemberSubject = 'http://www.w3.org/ns/ldp#MemberSubject';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#PreferContainment
 */
export const PreferContainment = 'http://www.w3.org/ns/ldp#PreferContainment';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#PreferMembership
 */
export const PreferMembership = 'http://www.w3.org/ns/ldp#PreferMembership';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#PreferEmptyContainer
 */
export const PreferEmptyContainer = 'http://www.w3.org/ns/ldp#PreferEmptyContainer';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#PreferMinimalContainer
 */
export const PreferMinimalContainer = 'http://www.w3.org/ns/ldp#PreferMinimalContainer';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#Ascending
 */
export const Ascending = 'http://www.w3.org/ns/ldp#Ascending';
/**
 *
 *
 *
 *
 * http://www.w3.org/ns/ldp#Descending
 */
export const Descending = 'http://www.w3.org/ns/ldp#Descending';
export const _BASE = 'http://www.w3.org/ns/ldp#';
export const _PREFIX = 'ldp';
//# sourceMappingURL=ldp.js.map